import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
import { TrainsService } from '../../services/trains.service';
import { TripsService } from '../../services/trips.service';
import { Trip } from '../../interfaces/trip';

@Component({
  selector: 'app-trainview',
  templateUrl: './trainview.component.html',
  styleUrls: ['./trainview.component.css']
})
export class TrainviewComponent implements OnInit {

  public trains: any[] = [];
  public realtime: boolean = true;

  constructor(private trainsService: TrainsService, private tripsService: TripsService, private router: Router) { }

  ngOnInit(): void {
    this.getTrains();

  }

  getTrains(): void {
    this.trainsService.get()
        .subscribe(trains => {
          this.trains = trains;
          this.realtime = this.trainsService.realtime;
        });
  }

  onDetail(trip: Trip): void{
    this.tripsService.detail(trip);
    this.router.navigate(['/trip/detail'])
  }

}
